/*------------------------------------*\
    MODULES
\*------------------------------------*/

/*------------------------------------*\
    EXAMPLE MODULE
\*------------------------------------*/
class FullwidthCarouselImage {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;



        function resizedImage() {
            let imageArray = document.querySelectorAll('.full-width-carousel__cell');


            for (let i = 0; i < imageArray.length; i++) {

                let str = imageArray[i].getAttribute('data-imgDesktop');
                let strTablet = imageArray[i].getAttribute('data-imgTablet');
                let strMobile = imageArray[i].getAttribute('data-imgMobile');

                if (window.matchMedia("(min-width: 1000px)").matches) {
                    imageArray[i].style.backgroundImage = `url('${str}')`;
                }

                if (window.matchMedia("(min-width: 501px) and (max-width: 999px)").matches) {
                    imageArray[i].style.backgroundImage = `url('${strTablet}')`;
                }

                if (window.matchMedia("(max-width: 500px)").matches) {
                    imageArray[i].style.backgroundImage = `url('${strMobile}')`;
                }
            }

        }

        resizedImage();

        window.addEventListener("resize", resizedImage);

    }
}

export default FullwidthCarouselImage;
